module.exports = "https://static.wmbcdn.com/uniweb/images/9d5f5d48a43471b55bb5e403a9899b39.svg";